function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgMessageCircleOff = function SvgMessageCircleOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.517 1.545a.688.688 0 00-.972.972l4.62 4.62a8.748 8.748 0 00-.594 8.378l-1.707 5.12a.71.71 0 00.898.898l5.12-1.707a8.743 8.743 0 008.377-.595l3.224 3.224a.688.688 0 10.972-.972L2.517 1.545zM17.227 18.2L7.197 8.17a7.33 7.33 0 00-1.004 3.703 7.22 7.22 0 00.776 3.273.71.71 0 01.04.545l-1.35 4.047 4.047-1.35a.71.71 0 01.545.04 7.22 7.22 0 003.275.776 7.326 7.326 0 003.701-1.004z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M21.353 15.784c-.112.222-.232.44-.36.65l-1.039-1.04a7.22 7.22 0 00.905-3.522l.002-.435c-.205-3.723-3.178-6.695-6.861-6.9h-.475a7.223 7.223 0 00-3.523.906L8.964 4.404a8.76 8.76 0 01.647-.358 8.637 8.637 0 013.916-.928l.512.001c4.445.245 7.994 3.794 8.24 8.279v.472a8.637 8.637 0 01-.926 3.914z",
    fill: props.color
  }));
};

SvgMessageCircleOff.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgMessageCircleOff.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgMessageCircleOff;